'use strict';

var forEach = require('../utils/foreach');

/**
 * The Class generator that extend the parent object with the child attributes appling the selected strategy
 *
 * @param {object} extendStrategies
 * @param {string} appliedStrategy
 * @param {object} parent
 * @param {object} child
 * @returns {Constructor}
 */
module.exports = function classGenerator(extendStrategies, appliedStrategy, parent, child) {
    if (typeof extendStrategies !== typeof parent || typeof parent !== typeof child || typeof child !== 'object' || typeof extendStrategies[appliedStrategy] === 'undefined') {
        throw new TypeError('The arguments aren\'t passed correctly');
    }

    /**
     *
     * @param {object} props
     * @param {object} opt
     * @constructor
     */
    function Constructor(props, opt) {
        this._init(props, opt);
    }

    Constructor.prototype = extendStrategies[appliedStrategy]({}, parent, child);

    forEach(extendStrategies, function (strategy, name) {
        /**
         * Apply an extend strategy to the class
         *
         * @param {object} child
         * @returns {*}
         */
        Constructor[name] = function (child) {
            return classGenerator(extendStrategies, name, Constructor.prototype, child);
        };
    });

    return Constructor;
};
